// extracted by mini-css-extract-plugin
export default {"status":"Status_status__jvQUK","pending":"Status_pending__oy6Ot","rejected":"Status_rejected__el9qI","completed":"Status_completed__RO+MG"};